import { Component, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'email-address',
  template: `<form #emailForm="ngForm">
              <div class="form-group">
                <label for="email">{{ 'email.emailLabel' | translate }}</label>
                <input type="email" class="form-control" id="email"
                        [required]="required" email
                       [(ngModel)]="emailAddress" (ngModelChange)="this.emailAddressChange.emit($event)" name="email"
                       #emailField="ngModel">

                <div *ngIf="emailField.invalid && (emailField.dirty || emailField.touched)"
                     class="alert alert-danger">
                  <div *ngIf="emailField.errors.required">
                    {{ 'email.emailRequiredMessage' | translate }}
                  </div>
                  <div *ngIf="emailField.errors.email">
                    {{ 'email.emailValidMessage' | translate }}
                  </div>
                </div>
              </div>
            </form>`,
})
export class EmailAddressComponent {
  @Input() required: boolean = true;
  @Input() emailAddress: string;
  @Output() emailAddressChange = new EventEmitter<string>();

  @ViewChild(NgForm) form;

  constructor() { }

}
